export default "__VITE_ASSET__930a7a17__"